import { Component, OnInit } from '@angular/core';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { ActivatedRoute } from '@angular/router';
import { EcommerceGenericoService } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { MarianomGeneral } from '../../marianom-general.service';

@Component({
  selector: 'modal-completar-pago',
  templateUrl: './modal-completar-pago.component.html',
  styleUrls: ['./modal-completar-pago.component.scss']
})
export class ModalCompletarPagoComponent implements OnInit {

  constructor(private modal: ModalService, private genServ: EcommerceGenericoService, private serv: MarianomGeneral, private router: ActivatedRoute) { }

  ngOnInit(): void {
  }

  aceptar() {
    this.modal.close('modal-completar-pago')
  }

  cancelarCompra() {
    this.genServ.cancelarPedidoWeb();
    this.genServ.resetEccomerce();
    this.serv.navigator.goLandPage(this.router);
    this.modal.close('modal-completar-pago');
  }

  volverAlCarrito() {
    this.genServ.cancelarPedidoWeb();
    this.serv.navigator.precierreCheckout(this.router);
    this.modal.close('modal-completar-pago');
  }

}
